import { render } from "./MatriculaController.vue?vue&type=template&id=4eb65cca"
import script from "./MatriculaController.vue?vue&type=script&lang=js"
export * from "./MatriculaController.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__